import React from 'react';
import { Avatar, Button, Checkbox, Loading, ModalBox, useModalContext, } from '@fourthwall/components';
import { pluralize } from '@fourthwall/utils/dist/string';
import { useUsersQuery } from '@queries/useUsersQuery';
import * as S from './styled';
export const SelectTeamStaff = ({ selectedTeamStaff, onSave }) => {
    const modal = useModalContext();
    const [innerSelectedTeamStaff, setInnerSelectedTeamStaff] = React.useState(selectedTeamStaff || []);
    const { usersQuery } = useUsersQuery();
    const users = usersQuery.data?.users.filter((user) => user.invitationStatus === 'FULFILLED');
    return (React.createElement(ModalBox, { title: "Select team members", onClose: modal.close, footer: React.createElement(React.Fragment, null,
            innerSelectedTeamStaff.length,
            " ",
            pluralize(innerSelectedTeamStaff.length, 'member'),
            ' ',
            "selected"), buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: modal.close }),
            React.createElement(Button, { label: "Save", appearance: "primary", onClick: () => {
                    onSave(innerSelectedTeamStaff);
                    modal.close();
                } }),
        ] },
        React.createElement(Loading, { isLoading: !users?.length },
            React.createElement(S.TableContainer, { id: "scrollableDiv" }, users?.map((user) => (React.createElement(S.Container, null,
                React.createElement(S.CheckboxContainer, null,
                    React.createElement(Checkbox, { value: !!innerSelectedTeamStaff.find((selectedMember) => selectedMember === user.email), onValueChange: (value) => {
                            if (value) {
                                setInnerSelectedTeamStaff((prevSelectedMembers) => [
                                    ...prevSelectedMembers,
                                    user.email,
                                ]);
                            }
                            else {
                                setInnerSelectedTeamStaff((prevSelectedMembers) => prevSelectedMembers.filter((prevSelecterMember) => prevSelecterMember !== user.email));
                            }
                        } })),
                React.createElement(Avatar, { name: user.fullName, size: "small" }),
                React.createElement(S.Nickname, null, user.fullName || user.email))))))));
};
